/* eslint-disable camelcase -- Google Consent Mode keys are snake_case by specification */
import type { ConsentObject } from './cookieConsent.types';

export const CONSENT_COOKIE_NAME = 'mw_consent';

export const CONSENT_COOKIE_EXPIRY_DAYS = 365;

// Dispatched on `window` after consent is successfully persisted, so other
// mounted consent UI (e.g. the preferences portal on /cookies) can refresh
// from the stored cookie without a full page reload.
export const CONSENT_CHANGED_EVENT = 'mw:consent-changed';

export const CONSENT_UPDATED_DATALAYER_EVENT = 'cookie_consent_updated';

export const COOKIE_POLICY_PATH = '/cookies';

export const ACCEPT_ALL_CONSENT: ConsentObject = {
  ad_personalization: 'granted',
  ad_storage: 'granted',
  ad_user_data: 'granted',
  analytics_storage: 'granted',
  functionality_storage: 'granted',
  personalization_storage: 'granted',
  security_storage: 'granted',
};

export const ESSENTIALS_ONLY_CONSENT: ConsentObject = {
  ad_personalization: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  analytics_storage: 'granted',
  functionality_storage: 'granted',
  personalization_storage: 'denied',
  security_storage: 'granted',
};
